<!--
  This is a temporary component to display the benchmark document items in a test page.
-->
<template>
  <div v-if="items && items.length > 0">
    <div v-for="item in items" :key="item.title">
      <sc-text :field="item.title" />
      <sc-text :field="item.pardotId" />
      <sc-text :field="item.fileName" />
      <sc-text :field="item.location" />
    </div>
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-Benchmark-Document',
  props: {
    items: {
      type: Array
    }
  },
  components: {
    ScText: Text
  }
};
</script>
